import { InteractionType, } from '@debbie/common/dist/interactions/index.js';
import React from 'react';
import AutoCall from './AutoCall.js';
import CreditorMessageSummary from './CreditorMessageSummary.js';
import DebtorMessageSummary from './DebtorMessageSummary.js';
import EBoksSummary from './EBoksSummary.js';
import EInvoiceSummary from './EInvoiceSummary.js';
import EmailSummary from './EmailSummary.js';
import LetterSummary from './LetterSummary.js';
import NoteSummary from './NoteSummary.js';
import PhoneSummary from './PhoneSummary.js';
import SMSSummary from './SMSSummary.js';
const Interaction = (props) => {
    return (React.createElement("div", null, (() => {
        switch (props.interaction.type) {
            case InteractionType.Email:
                return (React.createElement(EmailSummary, { interaction: props.interaction, longCaseId: props.longCaseId, showThread: props.showThread, setShowThread: props.setShowThread, replying: props.replying, setReplying: props.setReplying, alwaysExtended: props.alwaysExtended, notActionable: props.notActionable }));
            case InteractionType.Letter:
                return (React.createElement(LetterSummary, { interaction: props.interaction, notActionable: props.notActionable }));
            case InteractionType.Eboks:
                return (React.createElement(EBoksSummary, { interaction: props.interaction, notActionable: props.notActionable }));
            case InteractionType.Phone:
                return React.createElement(PhoneSummary, { ...props });
            case InteractionType.SMS:
                return React.createElement(SMSSummary, { ...props });
            case InteractionType.AutoCall:
                return React.createElement(AutoCall, { ...props });
            case InteractionType.Note:
                return React.createElement(NoteSummary, { ...props });
            case InteractionType.ClientNote:
                return (React.createElement(CreditorMessageSummary, { interaction: props.interaction, longCaseId: props.longCaseId, notActionable: props.notActionable }));
            case InteractionType.DebtorNote:
                return (React.createElement(DebtorMessageSummary, { interaction: props.interaction, longCaseId: props.longCaseId, notActionable: props.notActionable }));
            case InteractionType.EInvoice:
                return (React.createElement(EInvoiceSummary, { interaction: props.interaction }));
        }
    })()));
};
export default Interaction;
//# sourceMappingURL=Interaction.js.map